import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
export interface Crumb {
  label: string;
  to?: string;
}
export function Breadcrumbs({
  items
}: {
  items: Crumb[];
}) {
  return <nav aria-label="Breadcrumb" data-id="element-114" data-mp="1jeetq4mm7in7">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs font-medium text-ink-500" data-id="element-115" data-mp="1jddjg2dfb06j">
        {items.map((item, index) => <li key={`${item.label}-${index}`} className="flex items-center gap-1.5" data-id="element-116" data-mp="19hk1u4kukghw" data-mpi={index}>
            {item.to ? <Link to={item.to} className="rounded transition-colors hover:text-ink-900" data-id="element-117" data-mp="1egn4xjh9ocn8">
                {item.label}
              </Link> : <span className="text-ink-900" data-id="element-118" data-mp="10iyjoajaf3hn">{item.label}</span>}
            {index < items.length - 1 ? <ChevronRightIcon className="h-3.5 w-3.5 text-ink-300" aria-hidden="true" data-id="element-119" data-mp="2uuwjjlvpin0v" /> : null}
          </li>)}
      </ol>
    </nav>;
}